import React from 'react';

import classes from './ProfileTab.module.scss';
import { ScanIqCustomerPaymentTab } from '../../../../../payment';
import {
  LbTabPanel,
  LbTabs,
  LbVerticalPageTabsList,
  TabsConfig,
} from '../../../../../shared/components/tabs';
import { GeneralInfoTab } from './GeneralInfoTab/GeneralInfoTab';

type ProfileTabProps = {
  entityId: number;
  customerId: number;
};

const PROFILE_TABS = {
  GENERAL: 'GENERAL',
  PAYMENT: 'PAYMENT',
  INTEGRATIONS: 'INTEGRATIONS',
};

const ProfileTab = ({ entityId, customerId }: ProfileTabProps) => {
  const tabsConfig: TabsConfig[] = [
    {
      label: 'General',
      value: PROFILE_TABS.GENERAL,
      panel: <GeneralInfoTab />,
    },
    {
      label: 'Payment',
      value: PROFILE_TABS.PAYMENT,
      panel: <ScanIqCustomerPaymentTab entityId={entityId} customerId={customerId} />,
    },
    {
      label: 'Integrations',
      value: PROFILE_TABS.INTEGRATIONS,
      panel: <div>Integrations</div>,
    },
  ];

  return (
    <LbTabs className={classes.tabs} defaultValue={PROFILE_TABS.GENERAL}>
      <LbVerticalPageTabsList tabsConfig={tabsConfig} />
      <LbTabPanel tabsConfig={tabsConfig} />
    </LbTabs>
  );
};

export { ProfileTab };
